module.exports = __webpack_public_path__ + "media/images/logo-Beasy-153ad8eb72e03cd8e6a25bd8e088f0c8.svg";